import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Text } from 'foundations-components/components/Text';
import { trellisBreakpoint } from 'pricing-pages-lib/constants/Breakpoints';
import styled from 'foundations-theming/utils';
import { trackClickedLink } from '../../utils/tracking/trackingEventUtils';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledView = styled.div.withConfig({
  displayName: "FooterMicrocopy__StyledView",
  componentId: "sc-73kari-0"
})(({
  theme
}) => {
  return {
    clear: 'both',
    zIndex: 1,
    position: 'relative',
    paddingTop: theme.space[400],
    paddingBottom: theme.space[500],
    [trellisBreakpoint.tablet]: {
      paddingBlockStart: theme.space[1100],
      paddingInlineStart: theme.space[600],
      paddingInlineEnd: theme.space[700]
    }
  };
});
const FooterMicrocopy = () => {
  const handleClickLink = () => {
    trackClickedLink({
      name: 'product-services-catalog',
      value: 'Product and Services Catalog',
      type: 'external',
      url: 'https://legal.hubspot.com/hubspot-product-and-services-catalog'
    });
  };
  return /*#__PURE__*/_jsx(StyledView, {
    children: /*#__PURE__*/_jsx(Text, {
      textAlign: "center",
      color: "text-core-subtle",
      typography: "detail-100",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "pricingPage.productServicesCatalogPrompt_jsx",
        options: {
          onClick: handleClickLink
        },
        elements: {
          UILink: Link
        }
      })
    })
  });
};
export default FooterMicrocopy;